import getClientContext from '@ms/yammer-web-support/dist/clientContext';
import { writeHostingCookies } from '@ms/yammer-web-support/dist/hosting';
import { basenameForTeamsApp } from '@ms/yammer-web-support/dist/location';

type WriteCookies = (yammerToken: string, partitioned?: boolean) => void;
export const writeCookies: WriteCookies = (yammerToken, partitioned = false) => {
  const shouldSetSameSite = true;
  const shouldSetRingInfoCookie = true;
  const ringInfoCookiePath = basenameForTeamsApp;

  const { osName } = getClientContext();
  const shouldSetAuthCookieExpiry = osName == null || osName.toLowerCase() !== 'android';

  writeHostingCookies({
    yammerToken,
    shouldSetSameSite,
    shouldSetAuthCookieExpiry,
    shouldSetRingInfoCookie,
    ringInfoCookiePath,
    partitioned,
  });
};
